import * as React from 'react'
import { Element } from './warehouse_rent_list_types'

interface ElementInfoProps {
  element: Element
  reservedInCurrentList?: number
  reservedInOtherLists?: number
}

function ElementInfo({ element }: ElementInfoProps): React.ReactElement {
  return (
    <div className="rent-list-element-info">
      <h5>{element.name}</h5>
      <div className="mb-2">{`${element.sku}, H: ${element.width}, B: ${element.height}, D: ${element.depth}`}</div>
      <div className="rent-list-element-info-image-container">
        <img className="rent-list-element-info-image" src={element.photoThumb} alt={element.name} />
      </div>
    </div>
  )
}

export default ElementInfo
